import Alpine from "alpinejs";

Alpine.data("tabs", (initialActiveTab: string) => ({
  tabs: new Set<string>(),
  activeTab: initialActiveTab,

  init() {
    this.handleTabChange();
    window.addEventListener("hashchange", this.handleTabChange.bind(this));
  },

  handleTabChange() {
    const [id, search] = window.location.hash.split("?");
    const params = new URLSearchParams(search ?? "");
    const tab = params.get("tab");
    if (!tab) this.activeTab = initialActiveTab;
    else this.activeTab = tab;
  },

  tab: {
    ["x-init"]() {
      const handle = this.$el.dataset.handle;
      if (handle) this.tabs.add(handle);
    },

    [":data-ui"]() {
      if (this.activeTab !== this.$el.dataset.handle) return;
      return "active";
    },

    ["x-if"]() {
      return this.activeTab === this.$el.dataset.handle;
    },
  },

  link: {
    [":data-ui"]() {
      if (this.activeTab !== this.$el.dataset.handle) return;
      return "active";
    },

    ["@click"]() {
      const tab = this.$el.dataset.handle;
      const basePath = this.$el.dataset?.basePath ?? null;
      if (basePath) { window.history.replaceState({}, "", basePath); }
      window.location.hash = `#?tab=${tab}`;
    },
  },
}));
